import axios from "axios"
import { domain_member } from "./Constants"
import store from "../store"

const http = new axios.create({
    baseURL: domain_member
});

const httpMethod = {
    get(url, options = {}) {
        const token = store.state.auth.access_token;
        if (!token) {
            return Promise.reject("No access token.")
        }

        return http
            .get(url, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${token}`
                }
            })
            .then(res => res.data);
    },
    post(url, data = null, options = {}) {
        const token = store.state.auth.access_token;
        if (!token) {
            return Promise.reject("No access token.")
        }

        return http
            .post(url, data, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${token}`
                }
            })
            .then(res => res.data);
    },
    put(url, data = null, options = {}) {
        const token = store.state.auth.access_token;
        if (!token) {
            return Promise.reject("No access token.")
        }

        return http
            .put(url, data, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${token}`
                }
            })
            .then(res => res.data);
    },
    delete(url, options = {}) {
        const token = store.state.auth.access_token;
        if (!token) {
            return Promise.reject("No access token.")
        }

        return http
            .delete(url, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${token}`
                }
            })
            .then(res => res.data)
    }
};

export default httpMethod;
